import type { TranslationModule } from '../types';

export const tickerTranslations: TranslationModule = {
  ro: {
    ariaLabel: "Ultimele modificări legislative",
    latestChanges: "Ultimele modificări",
    news: "Noutăți",
    viewAll: "Vezi toate",
    modifyingAct: "Act modificator",
    modification: "modificare",
    completion: "completare",
    repeal: "abrogare",
    republication: "republicare",
    rectification: "rectificare"
  },
  en: {
    ariaLabel: "Latest legislative changes",
    latestChanges: "Latest changes",
    news: "News",
    viewAll: "View all",
    modifyingAct: "Modifying act",
    modification: "amendment",
    completion: "addition",
    repeal: "repeal",
    republication: "republication",
    rectification: "corrigendum"
  },
  fr: {
    ariaLabel: "Dernières modifications législatives",
    latestChanges: "Dernières modifications",
    news: "Actualités",
    viewAll: "Voir tout",
    modifyingAct: "Acte modificatif",
    modification: "modification",
    completion: "complément",
    repeal: "abrogation",
    republication: "republication",
    rectification: "rectification"
  }
};

export default tickerTranslations;
